var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('datatable',{attrs:{"columns":_vm.columns,"data":_vm.cancels},scopedSlots:_vm._u([{key:"no-results",fn:function(){return [_vm._v(" "+_vm._s(_vm.$t('no_data_available_on_table'))+" ")]},proxy:true}])})}
var staticRenderFns = []

export { render, staticRenderFns }